module.exports = __webpack_public_path__ + "img/alle disciplines--dark.27db37e4.svg";